module.exports = __webpack_public_path__ + "img/rs_card_envelope.e9d31543.png";